import { rem } from 'polished'
import styled, { css } from 'styled-components'

const OUTLINE_STROKE_COLOUR = '#BABCC2'

export const tripPlanTileOutlineHoverStyles = css`
  transition: border-color 220ms, box-shadow 220ms, transform 220ms, background-color 200ms, color 200ms;

  &:hover,
  &:focus-within {
    transform: translateY(-${rem(1)});

    .trip-plan-tile-outline__dashed {
      opacity: 0;
    }

    .trip-plan-tile-outline__solid {
      opacity: 1;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:hover,
    &:focus-within {
      transform: none;
    }
  }
`

type TileRadius = 'XS' | 'S' | 'M' | 'L' | 'round'

const DashedOutline = styled.svg<{ $radius: TileRadius }>`
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: visible;

  rect {
    fill: none;
    // Match the parent tile's corner radius (themed) so the outline aligns with
    // the actual tile corners rather than a hardcoded radius.
    rx: ${props => props.theme.borderRadius[props.$radius]};
    ry: ${props => props.theme.borderRadius[props.$radius]};
    stroke: ${OUTLINE_STROKE_COLOUR};
    stroke-width: 1;
    stroke-linecap: round;
    stroke-linejoin: round;
    vector-effect: non-scaling-stroke;
    transition: opacity 220ms;
  }

  .trip-plan-tile-outline__dashed {
    opacity: 1;
    stroke-dasharray: 4 4;
  }

  .trip-plan-tile-outline__solid {
    opacity: 0;
  }
`

function TripPlanTileDashedOutline({ radius = 'M' }: { radius?: TileRadius }) {
  return (
    <DashedOutline $radius={radius} aria-hidden="true" focusable="false">
      <rect className="trip-plan-tile-outline__solid" x="0" y="0" width="100%" height="100%" />
      <rect className="trip-plan-tile-outline__dashed" x="0" y="0" width="100%" height="100%" />
    </DashedOutline>
  )
}

export default TripPlanTileDashedOutline
